const BASE_DELAY_MS = 500;
export function getJitterDelay() {
    return Math.random() * BASE_DELAY_MS * 0.3;
}
//# sourceMappingURL=getJitterDelay.js.map